export default {
    header: {
        telefone: "Telefone",
        signIn: "Iniciar sessão",
        register: "Registar",
        becomeExpert: "Registe a sua empresa",
        dashboard: "Painel",

        sidebar: {
            tuktuk: {
                title: "Tuk Tuk",
                subtitle: "Reserva de Tuk Tuk",
                menu: {
                    grid: "Lista de Tuk Tuk",
                },
            },
            about: {
                title: "Sobre",
                subtitle: "Sobre",
                menu: {
                    aboutUs: "Sobre Nós",
                    testimonials: "Testemunhos",
                    faq: "Perguntas Frequentes",
                    contact: "Contacte-nos",
                    terms: "Termos e Condições",
                    privacy: "Política de Privacidade",
                },
            },
            dashboard: {
                title: "Painel",
                subtitle: "Painel do Usuário",
                subtitle2: "Painel do Agente",
                menu: {
                    dashboard: "Painel",
                    myBookings: "Minhas Reservas",
                    reviews: "Avaliações",
                    support: "Suporte",
                    wishlist: "Lista de Desejos",
                    wallet: "Carteira",
                    profileSettings: "Configurações de Perfil",
                    notifications: "Notificações",
                    myProfile: "Meu Perfil",
                    settings: "Configurações",
                    dashboard2: "Painel",
                    bookings: "Reservas",
                    enquiries: "Solicitações",
                    earnings: "Ganhos",
                    reviews2: "Avaliações",
                    settings2: "Configurações",
                },
            },
            social: {
                title: "Rede Social",
                subtitle: "Feed de Publicações",
                menu: {
                    feed: "Feed",
                    myProfilePage: "A Minha Página de Perfil",
                    explore: "Explorar",
                },
            },
        },
    },
    common: {
        welcome: "Bem-vindo, {{name}}!",
    },
    home: {
        hero: {
            title: "Aproxime-se do sonho:",
            title2: "os essenciais da sua viagem esperam por",
            title3: "si",
            subtitle: "O seu destino definitivo para tudo o que o ajuda a celebrar e recordar a sua experiência de viagem.",
            tukTuk: "Tuk Tuk",
        },
        searchBy: {
            titlePrefix: "Pacotes",
            titleSuffix: "recentes",
            subtitle:
                "Descubra os pacotes mais recentes adicionados à Portugalwaytour e explore oportunidades de viagem únicas cuidadosamente selecionadas para lhe proporcionar experiências inesquecíveis, novos destinos e aventuras exclusivas em todo o mundo.",
            noPackages: "Nenhum pacote recente encontrado.",
            hasDiferencial: "Tem diferencial",
            noReviews: "Sem avaliações",
            viewAll: "Ver todos os pacotes",
        },
        sectionBenefit: {
            titlePrefix: "Nossos",
            titleHighlight: "Benefícios",
            titleSuffix: "e principais vantagens",
            subtitle:
                "A Portugalway, uma operadora de turismo especializada em destinos dos sonhos, oferece uma variedade de benefícios para viajantes.",
            benefits: [
                {
                    title: "Experiências Autênticas",
                    description:
                        "Fuja do turismo tradicional e descubra o Portugal autêntico! Nossos passeios oferecem experiências genuínas explorando a cultura local, a culinária e lugares secretos.",
                },
                {
                    title: "Pacotes de Viagens Personalizados",
                    description:
                        "Crie a sua viagem sob medida! Escolha a sua experiência e nós cuidamos de tudo: alojamento, transporte e atividades, para uma viagem personalizada e inesquecível.",
                },
                {
                    title: "Conforto e Segurança",
                    description:
                        "Cuidamos de todos os detalhes: transporte confortável, alojamento selecionado e acompanhamento de guias profissionais, garantindo tranquilidade do início ao fim da viagem.",
                },
                {
                    title: "Atendimento Dedicado",
                    description:
                        "Desde o primeiro contacto até ao retorno da sua viagem, conta com suporte personalizado e uma equipa pronta para atender em português e inglês, com agilidade e atenção total às suas necessidades.",
                },
            ],
        },
        exploreCities: {
            title: "Explore por Cidade",
            subtitle: "Descubra experiências únicas em destinos incríveis",
        },
        placeSection: {
            titlePrefix: "Pacotes",
            titleHighlight: "em tendência",
            subtitle:
                "Explore os nossos pacotes de viagem mais populares, cuidadosamente selecionados pelas suas altas avaliações, comentários positivos e reservas frequentes de outros viajantes. Encontre a sua próxima aventura inesquecível aqui.",
            all: "Todos",
            hasDiferencial: "Tem diferencial",
            noReviews: "Sem avaliações",
            viewAll: "Ver todos os pacotes",
        },
        aboutSection: {
            welcome: "Bem-vindo à Portugalwaytour",
            title: "Explore para além do horizonte: descubra as maravilhas do mundo",
            description1: "Na Portugal Way Tour, acreditamos que viajar transforma. Somos uma agência especializada em experiências turísticas únicas em Portugal, dedicada a revelar o melhor do país — sua cultura, paisagens, história e autenticidade.",
            point1: "Proporcionar viagens memoráveis, com conforto, segurança e encanto. Queremos que cada visitante descubra Portugal de forma profunda, com roteiros que misturam tradição, natureza, gastronomia e hospitalidade genuína.",
            point2: "Ser referência de qualidade e confiança no turismo em Portugal, reconhecida por turistas de todo o mundo como sinónimo de profissionalismo e encantamento.",
            learnMore: "Saber mais",
            reviews: "{{count}}+ Avaliações"
        },
        aboutCounters: [
            { label: "Destinos pelo Mundo", icon: "isax-global5", colorClass: "text-teal" },
            { label: "Reservas Completas", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "Clientes Globalmente", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "Fornecedores Registados", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "Populares",
            popularSubtitle: "Descubra os serviços mais populares, bem avaliados e frequentemente reservados pelos viajantes.",
            serviceName: "Motorista de Tuk Tuk",
            loading: "Carregando...",
            reservationsSingular: "reserva",
            reservationsPlural: "reservas",
            viewProfile: "Ver Perfil",
            viewAll: "Ver Todos",
        },
        driverModal: {
            loading: "Carregando...",
            description: "Descrição",
            languages: "Idiomas",
            vehicle: "Veículo",
            seats: "lugares",
            averageRating: "Classificação Média",
            reviews: "Avaliações",
            packages: "Pacotes",
            noReviews: "Ainda sem avaliações",
            noPackages: "Este motorista não possui pacotes cadastrados",
        },
        testimonialSection: {
            title: "O que dizem os nossos {{highlight}}",
            highlight: "utilizadores",
            subtitle: "Confira o que os nossos viajantes acharam das suas experiências.",
            loading: "A carregar avaliações...",
            noReviews: "Nenhuma avaliação encontrada.",
            noComment: "O utilizador não deixou comentário.",
            viewPackage: "Ver detalhes do pacote"
        },
        updateSection: {
            faq: {
                title: "Perguntas {{highlight}}",
                highlight: "Frequentes",
                subtitle: "A Portugalway, uma operadora de turismo especializada em destinos de sonho, oferece uma variedade de benefícios para viajantes.",
                questions: [
                    {
                        question: "Como faço para reservar um tour?",
                        answer: "Pode reservar diretamente pelo nosso site ou entrar em contacto connosco por e-mail ou telefone. Após definir o roteiro desejado, passamos um orçamento, confirmamos hotéis e serviços, e solicitamos pagamento conforme política informada."
                    },
                    {
                        question: "É possível personalizar o roteiro?",
                        answer: "Sim! Todos os nossos roteiros são flexíveis. Escolhe os lugares que quer visitar, a duração, o tipo de alojamento e, dentro das possibilidades, criamos algo que combine com o seu perfil."
                    },
                    {
                        question: "Quais são os idiomas dos guias?",
                        answer: "Temos guias que falam português, inglês e, dependendo do tour, outros idiomas. Informe as suas preferências ao reservar para que possamos alocar o guia mais adequado."
                    },
                    {
                        question: "Como é a política de cancelamento?",
                        answer: "Temos uma política de cancelamento que varia conforme o tour, a antecedência e os fornecedores. No momento da reserva, enviamos os termos completos. Pedimos ler com atenção antes de confirmar."
                    },
                    {
                        question: "Quais são as formas de pagamento aceites?",
                        answer: "Aceitamos transferência bancária internacional, cartão de crédito e, em alguns casos, outros métodos de pagamento."
                    }
                ],
                contactUsText: "Caso não encontre a resposta à sua pergunta nas nossas Perguntas Frequentes, entre em contacto connosco. Responderemos em breve!",
                contactButton: "Contacte-nos",
            },
            support: {
                items: [
                    "Roteiros Personalizados",
                    "Planeamento Completo",
                    "Orientação de Especialistas",
                    "Experiência Local",
                    "Suporte ao Cliente",
                    "Esforços de Sustentabilidade",
                    "Múltiplas Regiões"
                ]
            }
        }
    },
    footer: {
        pages: {
            title: "Páginas",
            settings: "Definições",
            profile: "Perfil",
            social: "Rede Social",
        },
        company: {
            title: "Empresa",
            about: "Sobre Nós",
            testimonials: "Testemunhos",
            faq: "Perguntas Frequentes",
        },
        support: {
            title: "Apoio",
            contact: "Contacte-nos",
            privacy: "Política de Privacidade",
            terms: "Termos e Condições",
            chat: "Apoio via Chat",
        },
        services: {
            title: "Serviços",
            tuktuk: "Tuk Tuk",
            winery: "Adega",
            restaurant: "Restaurante",
            car: "Automóvel",
            hippotrip: "Hippotrip",
            bike: "Bicicleta",
        },
        bottom: {
            copyright: "Copyright © 2025. Todos os direitos reservados,",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "Aceda à sua conta",
            subtitle: "Introduza o seu e-mail para iniciar sessão ou criar uma conta",
            emailLabel: "E-mail",
            emailPlaceholder: "Introduza o seu e-mail",
            sendTestCode: "Enviar código de teste",
            sendEmailCode: "Enviar código por e-mail",
            codeLabel: "Código de verificação",
            codePlaceholder: "Introduza o código",
            verifyAndLogin: "Verificar e Entrar",
            testCodeSuccess: "Código de teste '123456' gerado. Utilize-o para iniciar sessão.",
            testCodeError: "Erro ao gerar código de teste.",
            emailSent: "Código enviado para o seu e-mail!",
            emailError: "Erro ao enviar o código por e-mail.",
            loginSuccess: "Sessão iniciada com sucesso!",
            invalidCode: "Código inválido ou expirado.",
            or: "Ou",
            google: "Google",
            facebook: "Facebook",
            reminderTitle: "Complete o seu perfil",
            reminderText: "Não se esqueça de completar o seu perfil para aproveitar todas as funcionalidades da plataforma!",
            gotIt: "Percebi",
        },
    },
    companyRegisterModal: {
        title: "Registo de Empresa",
        step1: "Por favor, insira o seu e-mail pessoal para criar uma conta do administrador da empresa. Usará esta conta para gerir o perfil da empresa.",
        step2: "Enviámos um código de verificação para o seu e-mail. Insira-o abaixo para verificar a sua identidade.",
        step3: "Agora preencha os dados da sua empresa. O e-mail da empresa deve ser um contacto corporativo (ex.: info@empresa.com).",

        personalEmail: "O seu e-mail pessoal",
        sendTestCode: "Enviar código de teste",
        sendEmailCode: "Enviar código por email",

        verificationCode: "Código de verificação",
        verifyCode: "Verificar código",

        companyEmail: "E-mail da empresa",
        companyName: "Nome da empresa",
        nif: "NIF",
        nib: "NIB",
        permanentCertificate: "Número da certidão permanente",
        phone: "Telefone",
        street: "Rua",
        city: "Cidade",
        postalCode: "Código postal",
        country: "País",
        companyDescription: "Breve descrição da empresa",
        servicesProvided: "Serviços fornecidos",

        contractTitle: "Contrato da Empresa",
        acceptContract: "Aceito o contrato da empresa",
        finishRegistration: "Concluir registo",

        messages: {
            "Test code sent successfully. Use '123456'.": "Código de teste enviado com sucesso. Use '123456'.",
            "Verification email sent successfully.": "Código enviado por email com sucesso.",
            "Verification successful.": "Verificação concluída com sucesso.",
            "Company registered and contract accepted successfully!": "Empresa registada e contrato aceite com sucesso!",
            testStepMessage: "Código de teste enviado com sucesso. Use '123456'.",
            emailStepMessage: "Um código de verificação foi enviado para o seu e-mail. Insira-o abaixo."
        },

        errors: {
            "Failed to send the verification code.": "Falha ao enviar o código de verificação.",
            "Invalid or expired code.": "Código inválido ou expirado.",
            "Please fill all required fields.": "Por favor, preencha todos os campos obrigatórios.",
            "You must accept the contract to register the company.": "Deve aceitar o contrato para registar a empresa.",
            "You must be logged in to register the company.": "Deve estar autenticado para registar a empresa.",
            "Failed to register the company or accept the contract.": "Falha ao registar a empresa ou aceitar o contrato."
        }
    },
    chooseUsSection: {
        title: "Por que nos Escolher?",
        cards: [
            {
                title: "Conveniência",
                description: "Planeie toda a sua viagem a partir de uma única plataforma, poupando tempo e esforço. Chega de alternar entre diferentes sites."
            },
            {
                title: "Garantia do melhor preço",
                description: "Trabalhamos com parceiros de viagem confiáveis para oferecer-lhe as melhores ofertas, seja reservando um voo, hotel ou aluguer de carro."
            },
            {
                title: "Suporte ao cliente",
                description: "A nossa equipa de suporte dedicada está à sua disposição 24 horas por dia, 7 dias por semana, garantindo que os seus planos de viagem decorram sem problemas do início ao fim."
            },
            {
                title: "Experiências de viagem personalizadas",
                description: "Quer viaje a negócios, férias em família ou numa aventura solo, oferecemos opções que atendem a todas as necessidades."
            }
        ]
    },
    contactUsSection: {
        breadcrumb: {
            home: "Início",
            pages: "Páginas",
            contactUs: "Contacto"
        },
        title: "Entre em contacto com a nossa equipa de suporte dedicada",
        description: "A nossa equipa está pronta para ajudar. A sua satisfação é a nossa prioridade.",
        info: [
            {
                label: "Endereço de email",
                value: "portugaltourway@gmail.com"
            },
            {
                label: "Número de telefone",
                value: "INSERT NUMBER"
            },
            {
                label: "A nossa localização",
                value: "INSERT RUA , Almada - Portugal"
            }
        ],
        supportCard: {
            title: "Precisa de suporte?",
            textLoggedOut: "Para entrar em contacto com a nossa equipa de suporte e abrir tickets, precisa de criar uma conta ou fazer login. Depois disso, terá acesso completo ao seu dashboard de suporte, onde poderá acompanhar e gerir os seus pedidos.",
            textLoggedIn: "Já está logado! Agora pode abrir um novo ticket de suporte ou acompanhar os tickets existentes diretamente no seu dashboard.",
            btnLoggedOut: "Criar Conta / Fazer Login",
            btnLoggedIn: "Abrir Ticket no Dashboard"
        }
    },
    sidebar: {
        main: "Principal",
        dashboard: "Painel",
        myBookings: "As Minhas Reservas",
        myReviews: "Avaliações",
        wishlist: "Lista de Desejos",
        support: "Suporte",
        finance: "Financeiro",
        wallet: "Carteira",
        payments: "Pagamentos",
        account: "Conta",
        myProfile: "O Meu Perfil",
        notifications: "Notificações",
        settings: "Definições",
        preferences: "Preferências",
        logout: "Sair",
    },

    agentSidebar: {
        dashboard: "Painel",
        bookings: "Reservas",
        tukTukBookings: "Reservas de Tuk Tuk",
        hotelBookings: "Reservas de Hotel",
        carBookings: "Reservas de Carro",
        cruiseBookings: "Reservas de Cruzeiro",
        tourBookings: "Reservas de Passeio",
        flightBookings: "Reservas de Voos",
        enquiries: "Consultas",
        earnings: "Ganhos",
        reviews: "Avaliações",
        support: "Suporte",
        serviceEnrollment: "Cadastro de Serviços",
        drivers: "Motoristas",
        tukTukVehicles: "Veículos de Tuk Tuk",
        settings: "Configurações",
        logout: "Sair",
    },

    dashboardCards: {
        totalBookings: "Total de Pacotes Comprados",
        totalListings: "Total de Pacotes",
        totalEarnings: "Total Ganhos",
        totalReviews: "Total Avaliações",
    },

    recentlyadded: {
        titulo: "Adicionado recentemente",
    },

    BookingsStatistics: {
        titulo: "Estatísticas de reservas",
        loading: "Carregando estatísticas...",
        none: "Nenhuma reserva registrada ainda.",
    },
};
